import {Trans} from '@lingui/macro';
import React, {ComponentProps, FC} from 'react';
import styled from 'styled-components';

import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {PaletteColorPicker} from '../../../components/common/color/paletteColorPicker';
import {TagEditorEmoji} from '../../../components/common/dropdowns/tags/tagEditorEmoji';
import {SkinTonesEnum} from '../../../models/api/preferencesModel';
import {EmojiDefinition} from '../../../services/emojis/emojis';
import {SettingsFieldLine} from '../../common/settingsFieldLine';

/*
 * Props.
 */

interface SettingsSingleTagHighlightFieldProps {
  onColorSelect: ComponentProps<typeof PaletteColorPicker>['onColorSelect'];
  onEmojiSelect: ComponentProps<typeof TagEditorEmoji>['onEmojiSelect'];
  isEmojiSelected: boolean;
  emoji: EmojiDefinition;
  skinTone: SkinTonesEnum | undefined;
  paletteColor: PaletteColorsEnum | undefined;
}

/*
 * Style.
 */

const StyledHighlightDiv = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  grid-column-gap: 5px;
  align-items: center;
  justify-content: center;
`;

/*
 * Component.
 */

export const SettingsSingleTagHighlightField: FC<SettingsSingleTagHighlightFieldProps> = (props) => {
  const renderPicker = () => (
    <StyledHighlightDiv>
      <PaletteColorPicker paletteColor={props.paletteColor} onColorSelect={props.onColorSelect} />
      <TagEditorEmoji
        isSelected={props.isEmojiSelected}
        emoji={props.emoji}
        skinTone={props.skinTone}
        onEmojiSelect={props.onEmojiSelect}
      />
    </StyledHighlightDiv>
  );

  return (
    <SettingsFieldLine
      title={<Trans id="settingstags-highlight-title">Color or emoji</Trans>}
      subtitle={<Trans id="settingstags-highlight-subtitle">Highlight your tag with helpful visuals</Trans>}
      content={renderPicker()}
    />
  );
};
